export const margin = '6%'
export const gutter = '2%'

export const containerLargeMargins = '5vw'
export const containerMediumMargins = '5vw'
export const containerSmallMargins = '20px'

const colSpacingSmall = '0'
const colSpacingMedium = '0'
const colSpacingLarge = '0'

const rowSpacingSmall = colSpacingSmall
const rowSpacingMedium = colSpacingMedium
const rowSpacingLarge = colSpacingLarge

const gridSettings = {
	colGap: [colSpacingSmall, colSpacingMedium, colSpacingLarge],
	rowGap: [rowSpacingSmall, rowSpacingMedium, rowSpacingLarge]
}

export default gridSettings
